'use strict';

import * as THREE from "three";
import { Buildings, settingsData, threeJsVariables } from '../../settings';
import { Vector3 } from 'three';
import { ViewMode } from '../../common';
import { getCurrentCameraDistance } from '../controls/orbitControls';
import {CSS2DObject} from "../../libs/CSS2DRenderer";
import {changeLangToCurrent} from "../language/langSwitcher";
import { intersectionClickHandler } from '../threejs/raycast';

/* Old version */

export const flatLabels = (currentFloor) => {

    const activeBuilding = Buildings.getActiveBuilding();
    const floor = activeBuilding.getFloorSelections(currentFloor);

    const scene = threeJsVariables.scene;
    const flaLabelsGroup = new THREE.Group();
    flaLabelsGroup.name = 'flaLabelsGroup';

    for (const apartment of floor) {

        if (apartment.name.match(/(amenity)|(Loby)|(lobby)|(Roof)|(roof)/g)) continue;

        let flatLabelContainer;
        let flatLabel;
        const center = apartment.getWorldPosition(new Vector3());

        // const floor = apartment.parent;

        //Apartment
        if (!apartment.name.toLowerCase().startsWith(config.resources.selectionBoxes.floorPlugName)){
            const aptCrmData = apartment.userData.crm_data;

            flatLabelContainer = getHtml(apartment, 'apt');

            flatLabel = new CSS2DObject(flatLabelContainer);
            flatLabel.element.setAttribute('data-apartment-name',apartment.name);
            flatLabel.element.onclick = (e) => apartmentLabelHandler(e.target);
        } else {

            flatLabelContainer = getHtml(apartment, 'plug');
            flatLabel = new CSS2DObject(flatLabelContainer);
        }

        flatLabel.userData.zoom = 0.1;
        flatLabel.name = `floor-label`;
        flatLabel.position.set(center.x, center.y + 2, center.z);
        // flatLabel.position.set(center.x, floor.position.y + 2, center.z);

        flaLabelsGroup.add(flatLabel);

    }

    scene.add(flaLabelsGroup);
}



/* New version */

// export const flatLabels = (currentFloor) => {
//
//     const activeBuilding = Buildings.getActiveBuilding();
//     const floor = activeBuilding.getFloorSelections(currentFloor);
//
//     // const scene = threeJsVariables.scene;
//     // const flaLabelsGroup = new THREE.Group();
//     // flaLabelsGroup.name = 'flaLabelsGroup';
//
//     for (const apartment of floor) {
//
//         if (apartment.name.match(/(amenity)|(Loby)|(lobby)|(Roof)|(roof)/g)) continue;
//
//         let flatLabelContainer;
//         let flatLabel;
//
//         //Apartment
//         if (!apartment.name.toLowerCase().startsWith(config.resources.selectionBoxes.floorPlugName)){
//
//             flatLabelContainer = getHtml(apartment, 'apt');
//
//             flatLabel = new CSS2DObject(flatLabelContainer);
//             flatLabel.element.setAttribute('data-apartment-name',apartment.name);
//             flatLabel.element.onclick = (e) => apartmentLabelHandler(e.target);
//         } else {
//
//             flatLabelContainer = getHtml(apartment, 'plug');
//             flatLabel = new CSS2DObject(flatLabelContainer);
//         }
//
//         flatLabel.userData.zoom = 0.1;
//         flatLabel.name = `floor-label`;
//
//         // flaLabelsGroup.add(flatLabel);
//         apartment.add(flatLabel);
//
//     }
//
//     // scene.add(flaLabelsGroup);
// }

function apartmentLabelHandler (target) {
    const flatContainer = target.closest('.flat-label-container');
    const aptName = flatContainer.getAttribute('data-apartment-name');
    const apt = threeJsVariables.scene.getObjectByName(aptName);
    intersectionClickHandler(apt);
}
export const flatLabelsRemove = () => {

    /* New Version */

    // const activeBuilding = Buildings.getActiveBuilding();
    //
    // activeBuilding.selectionsGroup.traverse(el =>{
    //    if (el.name === 'floor-label'){
    //        el.removeFromParent();
    //    }
    // });


   /* Old version */
    const scene = threeJsVariables.scene;

    if (scene.getObjectByName('flaLabelsGroup')) {
        const groupToRemove = scene.getObjectByName('flaLabelsGroup');
        scene.remove(groupToRemove);

        const labels = document.querySelectorAll('.flat-label-container');
        labels.forEach(item => {
            item.remove();
        });
    }
}

export function flatLabelResize () {
   if (settingsData.activeViewMode === ViewMode.FloorPlan){

       /* New version */
       // const currentCameraDistance = getCurrentCameraDistance();
       // const zoom = 1 / currentCameraDistance * 100 - 0.65;
       //
       // const activeBuilding = Buildings.getActiveBuilding();
       //
       // activeBuilding.selectionsGroup.traverse(el =>{
       //    if (el.name === 'floor-label'){
       //        el.userData.zoom = zoom > 1 ? 1 : zoom;
       //    }
       // });

      /* Old version */
       const labelsGroup = threeJsVariables.scene.getObjectByName('flaLabelsGroup');
       if (labelsGroup){
           const currentCameraDistance = getCurrentCameraDistance();
           const zoom = 1 / currentCameraDistance * 100 - 0.65;
           labelsGroup.traverse(label =>{
               if (label.type === 'Object3D'){
                   label.userData.zoom = zoom > 1 ? 1 : zoom;
               }
           });
       }
   }
}
export const flatLabelsUpdate = (currentFloor) => {
    flatLabelsRemove();
    flatLabels(currentFloor);
}

function getHtml(apartment, type) {
    const flatLabelContainer = document.createElement('div');
    flatLabelContainer.className = 'flat-label-container';
    const clickedApartment = settingsData.lastClickedFlat;
    const pointClasses = ['flat-label--point'];
    const icon360Classes = ['flat-label--icon'];
    let subTitleInfo;

    switch (type) {
        case 'apt':
            const crm = apartment.userData?.crm_data;
            if (!crm) return ;

            if (crm.status.toLowerCase() !== 'available') {
                pointClasses.push('unavailable');
                subTitleInfo = changeLangToCurrent(crm.status);
            } else {
                pointClasses.push('available');
                subTitleInfo = crm.modelName;
            }

            if (crm.assets.tours360) {
                icon360Classes.push('icon-360');
            }


            flatLabelContainer.innerHTML = `
                <div class='flat-label' data-apartment="${crm.bmbyPropID}">
                    <div class="${pointClasses.join(' ')}">
                        <div class="flat-label-text">
                             <h1 class="flat-label--title">${crm.propNum}</h1>
                            <h2 class="flat-label--subtitle language-string" data-dictionary="${crm.status}">${subTitleInfo}</h2>
                        </div>
                        <div class="flat-label-icon">
                            <span class="${icon360Classes.join(' ')}"></span>
                        </div>
                    </div>
                </div>`;

            break;
        case 'plug':

            flatLabelContainer.innerHTML = `
                <div class="flat-label-center">
                    <span class="language-string flat-label-center--title" data-dictionary="floor">${changeLangToCurrent('floor')}</span>
                    <span class="flat-label-center--number">${apartment.userData.floor}</span>
                </div>`;

            break;
    }

    return flatLabelContainer;
}